import _ from 'lodash'
import store from '@/store'

function resolveUrlPlaceholders(url, source = {}) {
  if (_.isEmpty(url)) {
    console.warn(`Expected url of type string to be provided, 
      but received ${url} with type ${typeof url}`)

    return ''
  }

  let resolvedUrl = url
  const customUserFieldRegex = /{{customUserField\.([a-zA-Z]+)}}/
  const customUserFieldRegexGlobal = new RegExp(
    customUserFieldRegex.source, `${customUserFieldRegex.flags}g`
  )
  const languageCodePlaceholder = '{{languageCode}}'

  if (customUserFieldRegex.test(resolvedUrl)) {
    let customFields = []

    if (_.isEmpty(source)) {
      const user = store.getters.user
      customFields = _.get(user, 'custom_fields', [])
    } else {
      customFields = _.get(source, 'custom_fields', [])
    }

    const customField = customFields.find((field) => {
      const placeholderKey =
        resolvedUrl.match(customUserFieldRegex)[1]

      return field.key === placeholderKey
    })

    const value = _.get(customField, 'value', '')

    resolvedUrl = resolvedUrl.replace(
      customUserFieldRegexGlobal, value
    )
  }

  if (resolvedUrl.includes(languageCodePlaceholder)) {
    const selectedLocale = store.state.locale
    resolvedUrl = resolvedUrl.replaceAll(languageCodePlaceholder, selectedLocale)
  }


  return resolvedUrl
}

function getUrlParameter(param, hashRoute= '#/') {
  if (typeof window !== 'undefined') {
    const newLocation = window.location.href.replace(hashRoute, '')
    const newUrl = new URL(newLocation)

    const query = newUrl.search.substring(1)
    const vars = query.split('&')

    for (let x = 0; x < vars.length; x++) {
      const pair = vars[x].split('=')

      if (pair[0] === param) {
        return decodeURIComponent(pair[1])
      }
    }
  }

  return false
}

function getListOfUrlParameters(paramsToRetrieve = [], hashRoute = '#/') {
  let retrievedParams = {}
  for (let param of paramsToRetrieve) {
    if (!retrievedParams[param] && getUrlParameter(param, hashRoute)) {
      retrievedParams[param] = getUrlParameter(param, hashRoute)
    }
  }
  return retrievedParams
}

export {
  resolveUrlPlaceholders,
  getUrlParameter,
  getListOfUrlParameters
}
